module.exports = __webpack_public_path__ + "img/expense_category_general.87f015b.png";